import React, { useState } from "react";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
import { AiFillEye, AiFillEdit, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";

const HiringList = ({ forms, sort, setSort, handleFormsView, page, setPage, getForms }) => {
  const { t } = useTranslation();
  
  return (
    <div className="p-3">
      <div className="rounded-lg border overflow-x-auto relative ">
        <table className="dark:text-gray-400 w-full text-xs text-left text-[#A5A5A5] ">
          <thead className="dark:bg-gray-700 dark:text-gray-400 text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] ">
            <tr>
              <th className="py-3 px-6" scope="col">
                Sr no.
              </th>
              <th scope="col" className="px-6 py-3 ">
                {t("TITLE")}
              </th>
              <th
                className="cursor-pointer py-3 px-6 "
                scope="col"
                onClick={() => {
                  if (sort.sortType === "asc" && sort.sortBy === "createdAt") {
                    setSort({
                      sortBy: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortType: "asc",
                      sortBy: "createdAt",
                    });
                  }
                }}
              >
                <div className="justify-start flex ">
                  <span>{t("CREATED_DATE")}</span>
                  <span>
                    {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="h-4 rotate-180 w-4 " />}
                  </span>
                </div>
              </th>
              <th className="text-center py-3 px-6" scope="col">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
          {forms &&
              forms?.map((item, i) => (
                <tr key={i} className="dark:bg-gray-800 dark:border-gray-700 bg-white border-b ">
                  <th className="font-medium text-gray-900 py-4 px-6 border-r dark:text-white" scope="row">
                    {Math.max(1, (page - 1) * 10 + i + 1)}
                  </th>
                  <td className="text-gray-900 py-4 px-6 border-r ">{item?.formName} </td>
                  <td className="py-4 border-r px-6 text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} </td>
                  <td className="border-l py-4 px-6 text-gray-900">
                    <div className="">
                      <ul className="justify-center flex ">
                        <li className="hover:text-LightBlue px-2 py-2 hover:bg-white " onClick={() => handleFormsView(item?._id)}>
                          <a title={t("O_VIEW_USER")}>
                            {" "}
                            <AiFillEye className="w-5 h-5 cursor-pointer text-slate-600" />{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
                {isEmpty(forms) ? (
                  <tr className="dark:bg-gray-800 bg-white text-center border-b dark:border-gray-700">
                    <td colSpan={4} className="border-r py-4 px-6 ">
                      {t("O_NO_RECORD_FOUND")}
                    </td>
                  </tr>
                ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HiringList;
